import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash/fp';
import EmployeeForm from '../EmployeeForm';
import { useMutation } from '../../../../../graphql/hooks';
import { CREATE_EMPLOYEE, CreateEmployeeFormQuery, GET_EMPLOYEES } from '../../../graphql';
import { CreateEmployeeFormQueryProps, CreateEmployeeMutationResult, OnSubmitType } from '../types';
import Query from '../../../../../graphql/Query';
import { mapIds } from '../../../../../utils';
import { routePaths } from '../../../../../routePaths';
import { Card, Typography } from '../../../../../ui-kit';
import { useUser } from '../../../../../utils/hooks/auth';

const CreateEmployeeForm = () => {
    const { user } = useUser();
    const [create, { loading }] = useMutation<CreateEmployeeMutationResult>(
        CREATE_EMPLOYEE,
        { refetchQueries: [{ query: GET_EMPLOYEES }] },
    );

    const history = useHistory();

    const onSubmit: OnSubmitType = async values => {
        const { venueIds, defaultVenueId = user.currentVenueId, ...rest } = values;
        const mappedVenueIds: string[] = isEmpty(venueIds) ? [defaultVenueId] : mapIds(venueIds);

        const variables = { ...rest, venueIds: mappedVenueIds, defaultVenueId };
        try {
            await create({ variables });
            history.push(routePaths.employee);
        } catch (error) {
            // nothing we can do
        }
    };
    const { t } = useTranslation();

    return (
        <Query<CreateEmployeeFormQueryProps> query={CreateEmployeeFormQuery}>
            {({ data: { venues } }) => {
                return (
                    <Card>
                        <Box px={3} py={5}>
                            <Box>
                                <Typography variant='h6' component='h1'>{t('Create Member')}</Typography>
                            </Box>
                            <EmployeeForm
                                venues={venues}
                                onSubmit={onSubmit}
                                isLoading={loading}
                                submitText={t('Create')}
                            />
                        </Box>
                    </Card>
            );
            }}
        </Query>
    );
};

export default CreateEmployeeForm;
